import { routes as auth } from './auth'
import { routes as settings } from './settings'
import { routes as patient } from './patient'
import { routes as employee } from './employee'
import { routes as professional } from './professional'
import { routes as team } from './team'
import { routes as profilePublic } from './profile-public'
import { routes as dweller } from './dweller'
import { routes as tenant } from './tenant'

const index = {
  name: 'index',
  path: '/',
  redirect: {name: 'dashboard'}
}

const dashboard = {
  name: 'dashboard',
  path: '/dashboard'
}

export default [
  ...auth,
  ...settings,
  ...patient,
  ...employee,
  ...professional,
  ...team,
  ...profilePublic,
  ...dweller,
  ...tenant,
  index,
  dashboard
]



// WEBPACK FOOTER //
// ./src/app/routes.js